<tmn-header-bar [teamsCampaignVisible]="(isUserAuthorizedToTeamsCampaign$ | async)!" [thresholdsVisible]="(hasRightToConfigureThresholds$ | async)!"></tmn-header-bar>
<div class="router">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- Chatbot: l'élément <mini-chatbot> est injecté à l'intérieur de <tmn-chatbot/> -->
<tmn-chatbot></tmn-chatbot>
